import AscAircraftDataContainer from './containers/AscAircraftDataContainer.vue'
import { role } from '@/utilities/userRoles'

const aircraftDataRouter = {
  icon: 'mdi-airplane',
  path: '/aircraft-data',
  name: 'Aircraft Data',
  display: false,
  component: AscAircraftDataContainer,
  meta: {
    primaryNavigation: false,
    requiresRole: role.airlineUser,
    requiresEccn: false,
    tooltip: 'View aircraft data',
    breadcrumbs: [
      {
        text: 'Home',
        to: '/',
      },
      {
        text: 'Aircraft Data',
      },
    ],
  },
  children: [],
}

export default aircraftDataRouter
